/* DECOMURA · Realizacje v2 (sections/dcm-realizacje.liquid). Bez zależności, DOM bez wstawiania HTML. Opis i uzasadnienia: README paczki. */
(function () {
'use strict';
if (window.DcmRealizacje) { window.DcmRealizacje.scan(document); return; }

var VARIANTS = ['reel', 'video', 'photo', 'album', 'share_ig', 'share_partner', 'share_link'];
var HANDLE_RE = /^[a-z0-9][a-z0-9_-]{0,254}$/;

/* == narzędzia == */
function noop() {}
function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
function attrs(e, o) { for (var k in o) { if (o[k] != null) e.setAttribute(k, String(o[k])); } return e; }
function el(tag, cls, text, at) {
  var e = document.createElement(tag);
  if (cls) e.className = cls;
  if (text != null) e.textContent = text;
  return at ? attrs(e, at) : e;
}
function on(node, type, fn, opt) { node.addEventListener(type, fn, opt); return node; }
function txt(s) { return document.createTextNode(s); }
function add(parent, child) { parent.appendChild(child); return child; }
function each(list, fn) { Array.prototype.forEach.call(list, fn); }
function btn(cls, text) { var b = el('button', cls, text); b.setAttribute('type', 'button'); return b; }
/* tylko https:// albo ścieżka „/x” */
function safeUrl(u) {
  if (typeof u !== 'string') return null;
  u = u.trim();
  return /^(https:\/\/|\/(?![/\\]))/i.test(u) && !/[\x00-\x20\\]/.test(u) ? u : null;
}
function num(n) { return typeof n === 'number' && isFinite(n) ? n : null; }
function hexColor(c) { return typeof c === 'string' && /^#[0-9a-f]{3,8}$/i.test(c) ? c : null; }
function clamp(r, a, b) { return Math.min(b, Math.max(a, r)); }
function clampRatio(r) { r = num(r); return r && r > 0 ? clamp(r, 0.5, 1.91) : 1; }
function ratioOf(m) { return m && num(m.width) && num(m.height) ? m.width / m.height : 1; }
/* kolaż wg orientacji: [klasa, proporcja] */
function albumLayout(imgs) {
  var n = Math.min(5, imgs.length), r0 = ratioOf(imgs[0]), l0 = r0 > 1.1;
  if (n === 2) return l0 && ratioOf(imgs[1]) > 1.1 ? ['2', 8 / 9] : ['2h', 2 * clamp((r0 + ratioOf(imgs[1])) / 2, 0.8, 1)];
  if (n === 3) return [l0 ? '3l' : '3', 1];
  if (n === 4) return l0 ? ['4l', 1.116] : [r0 >= 0.9 ? '4s' : '4', 1];
  return ['5', 1.2];
}
var NOSCROLL = { preventScroll: true }, HIDE = { 'aria-hidden': 'true' };
var SHEET = '(max-width: 749px), (max-width: 989px) and (max-height: 500px)';
function tileRatio(r) {
  r = clampRatio(r);
  return r > 1 ? 1 : [2 / 3, 0.8, 1].reduce(function (b, c) { return Math.abs(c - r) < Math.abs(b - r) ? c : b; }, 1);
}
function expiringSoon(v) {
  if (!v || !v.expires_at) return false;
  var t = Date.parse(v.expires_at);
  return isFinite(t) && t - Date.now() < 10 * 60 * 1000;
}
function fmtDur(s) {
  s = num(s); if (!s || s <= 0) return '';
  s = Math.round(s);
  var m = Math.floor(s / 60), r = s % 60;
  return m + ':' + (r < 10 ? '0' : '') + r;
}
function cleanUrl() { return location.pathname + location.search; }
function track(ev, item, platform) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: ev, realizacja_id: item ? item.id : null, realizacja_variant: item ? item.variant : null, platform: item ? item.platform : (platform || null) });
  } catch (e) {}
}

/* == tłumaczenia == */
var DICT = null, MISSING = {};
function dict() {
  if (DICT) return DICT;
  DICT = {};
  try { var n = document.getElementById('dcm-staging-i18n'); if (n) DICT = JSON.parse(n.textContent) || {}; } catch (e) { DICT = {}; }
  return DICT;
}
function raw(key) {
  var s = dict()[key];
  if (typeof s === 'string' && s && s.indexOf('translation missing') !== 0) return s;
  if (!MISSING[key]) { MISSING[key] = 1; try { console.warn('dcm-realizacje: brak tłumaczenia dcm_staging.' + key + ' w dcm_keys'); } catch (e) {} }
  return '';
}
function fill(s, vals) {
  for (var k in vals) { if (Object.prototype.hasOwnProperty.call(vals, k)) s = s.split('[' + k + ']').join(String(vals[k])); }
  return s;
}
function t(key, vals) { return fill(raw(key), vals || {}); }

/* == jeden odtwarzacz na stronę (wszystkie instancje) == */
var PLAYER = window.__dcmRzPlayer || (window.__dcmRzPlayer = (function () {
  var list = [];
  function prune() { list = list.filter(function (v) { return v.isConnected; }); }
  function pause() { list.forEach(function (x) { try { x.pause(); } catch (_) {} }); }
  on(document, 'play', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || list.indexOf(v) < 0) return;
    prune();
    list.forEach(function (x) { if (x !== v && !x.paused) { try { x.pause(); } catch (_) {} } });
  }, true);
  on(document, 'visibilitychange', function () { if (document.hidden) pause(); });
  return {
    pause: pause,
    track: function (v) { prune(); if (list.indexOf(v) < 0) list.push(v); },
    stopIn: function (node) {
      list.forEach(function (x) {
        if (!node.contains(x)) return;
        try { x.pause(); x.removeAttribute('src'); x.load(); } catch (_) {}
      });
      prune();
    }
  };
})());

/* == ikony (SVG przez createElementNS) == */
var NS = 'http://www.w3.org/2000/svg';
/* [viewBox, obrys, wypełnienie] */
var ICONS = {
  fb: [16, 'M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z', 'M8.9 14.6V8.9h1.7l.3-1.9h-2V5.9c0-.6.2-1 1-1h1.1V3.3c-.2 0-.8-.1-1.5-.1-1.5 0-2.5.9-2.5 2.6V7H5.4v1.9H7v5.5'],
  ig: [16, 'M5.4 1.8h5.2a3.6 3.6 0 0 1 3.6 3.6v5.2a3.6 3.6 0 0 1-3.6 3.6H5.4a3.6 3.6 0 0 1-3.6-3.6V5.4a3.6 3.6 0 0 1 3.6-3.6ZM10.9 8a2.9 2.9 0 1 1-5.8 0 2.9 2.9 0 0 1 5.8 0Z', 'M12.4 4.4a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Z'],
  eye: [16, 'M1.5 8S3.9 3.6 8 3.6 14.5 8 14.5 8 12.1 12.4 8 12.4 1.5 8 1.5 8ZM10.1 8a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0Z'],
  heart: [16, 'M8 13.6S2 9.9 2 5.9a3 3 0 0 1 6-1.2 3 3 0 0 1 6 1.2c0 4-6 7.7-6 7.7Z'],
  chat: [16, 'M2.5 3h11v8H7.2l-3.2 2.4V11H2.5Z'],
  arrow: [16, 'M3 8h10M9 4l4 4-4 4'],
  share: [16, 'M8 10V2.5M5 5.5l3-3 3 3M3 8.5v5h10v-5'],
  repost: [16, 'M3 6.5h9l-2.5-2.5M13 9.5H4l2.5 2.5'],
  play: [20, '', 'M5.5 3.2v13.6L17 10Z'],
  reel: [16, 'M5 2h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Z', 'M6.6 5.4v5.2L10.8 8Z'],
  album: [16, 'M5.7 4.5h6.6c.7 0 1.2.5 1.2 1.2v6.6c0 .7-.5 1.2-1.2 1.2H5.7c-.7 0-1.2-.5-1.2-1.2V5.7c0-.7.5-1.2 1.2-1.2ZM2.5 11.2V3.7c0-.7.5-1.2 1.2-1.2h7.5'],
  close: [16, 'M3.5 3.5l9 9M12.5 3.5l-9 9'],
  left: [16, 'M10 3 5 8l5 5'],
  right: [16, 'M6 3l5 5-5 5'],
  broken: [24, 'M4.5 4h15c.8 0 1.5.7 1.5 1.5v13c0 .8-.7 1.5-1.5 1.5h-15c-.8 0-1.5-.7-1.5-1.5v-13C3 4.7 3.7 4 4.5 4ZM3 16l5-5 4 4 3-3 6 6M4 3l16 18']
};
function icon(name, cls) {
  var def = ICONS[name], s = document.createElementNS(NS, 'svg');
  attrs(s, { viewBox: '0 0 ' + def[0] + ' ' + def[0], 'aria-hidden': 'true', focusable: 'false', class: cls || 'dcm-rz-ic' });
  if (def[1]) add(s, attrs(document.createElementNS(NS, 'path'), { d: def[1] }));
  if (def[2]) add(s, attrs(document.createElementNS(NS, 'path'), { d: def[2], style: 'fill:currentColor;stroke:none' }));
  return s;
}
function avatar(ig, old) {
  var n = ig ? 'ig' : 'fb', s = icon(n, 'dcm-rz-av dcm-rz-av--' + n);
  if (old) old.replaceWith(s);
  return s;
}
function unavailable(link, cls) {
  var box = el('span', cls || 'dcm-rz-unav');
  add(box, icon('broken'));
  add(box, el('span', null, t('rz_unavailable')));
  if (link) add(box, extLink(link, t('rz_view_original'), 'dcm-rz__link'));
  return box;
}
function extLink(href, text, cls) {
  var a = el('a', cls, text, { href: href, target: '_blank', rel: 'noopener' });
  add(a, el('span', 'dcm-rz-vh', ' ' + t('rz_new_tab')));
  return a;
}

/* == zapytania == */
/* limit czasu obejmuje też ciało odpowiedzi */
function getJson(url, ms, credentials) {
  var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
  return new Promise(function (ok, no) {
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); no(new Error('timeout')); }, ms || 8000);
    fetch(url, { signal: ctrl ? ctrl.signal : undefined, credentials: credentials || 'omit' }).then(function (r) {
      if (!r.ok) { var e = new Error('HTTP ' + r.status); e.status = r.status; throw e; }
      return r.json();
    }).then(ok, no).then(function () { clearTimeout(timer); });
  });
}
var PRODUCTS = {};
function productState(root, handle) {
  var key = root + '|' + handle;
  if (!PRODUCTS[key]) {
    var st = { done: false, data: null };
    st.p = getJson(root + 'products/' + encodeURIComponent(handle) + '?view=dcm-rz', 6000, 'same-origin').then(function (d) {
      if (!d || typeof d.title !== 'string') throw new Error('shape');
      if (d.image && /^\/\/[^/\\]/.test(d.image.src)) d.image.src = 'https:' + d.image.src;
      st.data = d; st.done = true; return d;
    }, function (e) { st.done = true; st.data = null; throw e; });
    st.p.catch(noop);
    PRODUCTS[key] = st;
  }
  return PRODUCTS[key];
}
var FONTS = null;
function fontsReady(node) {
  if (FONTS) return FONTS;
  var f = document.fonts;
  if (!f || typeof f.load !== 'function') return (FONTS = Promise.resolve());
  var fam = getComputedStyle(node).fontFamily || 'sans-serif';
  FONTS = Promise.race([Promise.all([f.load('400 14px ' + fam), f.load('700 14px ' + fam)]).catch(noop), sleep(400)]);
  return FONTS;
}
function sanitize(list) {
  return (Array.isArray(list) ? list : []).filter(function (it) {
    return it && typeof it === 'object' && (typeof it.id === 'string' || typeof it.id === 'number') && VARIANTS.indexOf(it.variant) >= 0;
  }).map(function (it) {
    it.id = String(it.id);
    it.platform = it.platform === 'instagram' ? 'instagram' : 'facebook';
    it.media = it.media && typeof it.media === 'object' ? it.media : {};
    it.caption = typeof it.caption === 'string' && it.caption.trim() ? it.caption : null;
    return it;
  });
}
function images(md) {
  return (Array.isArray(md.images) ? md.images : []).filter(function (m) { return m && safeUrl(m.src || m.src_small); });
}
function coverOf(md) { return md.cover && safeUrl(md.cover.src || md.cover.src_small) ? md.cover : images(md)[0]; }
function handleOf(it) { var p = it.product; return p && typeof p.handle === 'string' && HANDLE_RE.test(p.handle) ? p.handle : null; }
function isShare(it) { return it.variant.indexOf('share_') === 0; }
function playable(it) { var v = it.media.video; return v && safeUrl(v.src) ? v : null; }

/* == instancja sekcji == */
var UID = 0;
function Inst(root) {
  var self = this, ds = root.dataset;
  root.__dcmRz = this;
  this.root = root;
  this.sid = ds.sectionId || String(++UID);
  this.mode = ds.mode === 'module' ? 'module' : 'page';
  this.api = (ds.api || 'https://decomura-erp.vercel.app').replace(/\/+$/, '');
  this.limit = Math.min(24, Math.max(1, parseInt(ds.limit, 10) || 12));
  this.locale = ds.locale || document.documentElement.lang || 'pl';
  var r = ds.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  this.base = ('/' + r + '/').replace(/\/+/g, '/');
  this.filters = ds.filters !== 'false';
  this.samples = safeUrl(ds.samples) || this.base + 'pages/zamow-bezplatne-probki';
  this.level = ds.level === '3' ? 'h3' : 'h2';
  this.q = function (s) { return root.querySelector(s); };
  this.grid = this.q('[data-rz-grid]');
  this.live = this.q('[data-rz-live]');
  this.msg = this.q('[data-rz-msg]');
  this.foot = this.q('[data-rz-foot]');
  this.status = this.q('[data-rz-status]');
  this.more = this.q('[data-rz-more]');
  this.moreErr = this.q('[data-rz-more-error]');
  this.filtersEl = this.q('[data-rz-filters]');
  this.countEl = this.q('[data-rz-n]');
  this.skip = this.q('[data-rz-skip]');
  this.toastEl = this.q('[data-rz-toast]');
  this.skel = Array.prototype.map.call(this.grid.children, function (n) { return n.cloneNode(true); });
  this.items = []; this.total = {}; this.next = null; this.platform = 'all'; this.seq = 0; this.tries = 0;
  this.view = root.classList.contains('is-posts') ? 'posts' : 'grid';
  this.mq = window.matchMedia('(min-width: 750px)');
  this.onMq = function () { if (self.items.length) self.render(); };
  if (this.mq.addEventListener) on(this.mq, 'change', this.onMq); else this.mq.addListener(this.onMq);
  this.onPop = function () { self.popstate(); };
  on(window, 'popstate', this.onPop);
  each(root.querySelectorAll('[data-rz-view]'), function (b) {
    b.setAttribute('aria-pressed', String(b.getAttribute('data-rz-view') === self.view));
    on(b, 'click', function () { self.setView(b.getAttribute('data-rz-view')); });
  });
  if (this.more) on(this.more, 'click', function () { self.loadMore(true); });
  this.loadFirst();
}
var P = Inst.prototype;

P.apiUrl = function (params) {
  var q = [];
  for (var k in params) { if (params[k] != null && params[k] !== '') q.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k])); }
  return this.api + '/api/public/realizacje?' + q.join('&');
};
P.totalFor = function () {
  var v = this.platform === 'all' ? this.total.all : this.total[this.platform];
  return typeof v === 'number' ? v : this.items.length;
};
P.plural = function (base, n) {
  var cat = 'other';
  try { cat = new Intl.PluralRules(this.locale).select(n); } catch (e) {}
  return t(raw(base + '_' + cat) ? base + '_' + cat : base + '_other', { n: this.fmtNum(n) });
};
P.fmtNum = function (n, compact) {
  try { return new Intl.NumberFormat(this.locale, compact ? { notation: 'compact', maximumFractionDigits: 1 } : {}).format(n); } catch (e) { return String(n); }
};
P.fmtDate = function (iso) {
  if (typeof iso !== 'string') return '';
  var d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  var o = { day: 'numeric', month: 'long' };
  if (d.getFullYear() !== new Date().getFullYear()) o.year = 'numeric';
  try { return new Intl.DateTimeFormat(this.locale, o).format(d); } catch (e) { return iso.slice(0, 10); }
};
P.count = function (it) { var md = it.media; return Math.max(num(md.image_count) || 0, images(md).length); };
P.typeText = function (it) {
  var v = it.variant, s;
  if (v === 'reel') s = t('rz_type_reel');
  else if (v === 'video') s = t('rz_type_video');
  else if (v === 'album') s = t('rz_type_album');
  else if (v === 'photo') s = t(it.platform === 'instagram' ? 'rz_type_post' : 'rz_type_photo');
  else s = t('rz_type_share');
  if (v === 'album' && this.count(it) > 1) s += ' · ' + this.plural('rz_photos', this.count(it));
  return s;
};
P.label = function (it) {
  var s = this.typeText(it).replace(' · ', ', '), d = this.fmtDate(it.posted_at);
  if (d) s += ', ' + d;
  if (it.caption) {
    var c = Array.from(it.caption.replace(/\s+/g, ' ').trim());
    s += '. ' + (c.length > 80 ? c.slice(0, 79).join('') + '…' : c.join(''));
  }
  return s;
};

/* == wczytywanie == */
P.loadFirst = function () {
  var self = this, seq = ++this.seq, attempt = 0;
  var url = this.apiUrl({ platform: this.platform === 'all' ? null : this.platform, limit: this.limit });
  function go() {
    return getJson(url).catch(function (e) {
      if (attempt++ < 1 && !(e.status >= 400 && e.status < 500)) return sleep(2000).then(go);
      throw e;
    });
  }
  return Promise.all([go(), fontsReady(this.root)]).then(function (res) {
    var data = res[0];
    if (!data || !Array.isArray(data.items)) throw new Error('shape');
    var items = sanitize(data.items);
    return self.prefetch(items).then(function () {
      if (seq !== self.seq) return;
      self.total = data.total && typeof data.total === 'object' ? data.total : {};
      self.next = typeof data.next_cursor === 'string' && data.next_cursor ? data.next_cursor : null;
      self.items = items;
      self.tries = 0;
      self.grid.style.opacity = '';
      if (!items.length) { if (self.platform === 'all') self.showEmpty(); else self.showEmptyFilter(); return; }
      self.msg.hidden = true;
      self.renderFilters();
      self.render();
      self.updateFoot();
      if (self.retryFocus) { self.retryFocus = false; var f = self.grid.querySelector('.dcm-rz-hit, .dcm-rz-tile'); if (f) f.focus(NOSCROLL); }
      self.handleHash();
    });
  }).catch(function () { if (seq === self.seq) self.showError(); });
};
P.prefetch = function (items) {
  var self = this, ps = [];
  if (this.kind() === 'tile') return Promise.resolve();
  items.forEach(function (it) { var h = handleOf(it); if (h) ps.push(productState(self.base, h).p.catch(noop)); });
  return ps.length ? Promise.race([Promise.all(ps), sleep(1500)]) : Promise.resolve();
};
P.loadMore = function (focusNew) {
  var self = this;
  if (this.busy || !this.next) return Promise.resolve(false);
  var seq = this.seq;
  this.busy = true;
  if (this.more) this.more.setAttribute('aria-busy', 'true');
  this.moreErr.hidden = true;
  track('realizacje_load_more', null, this.platform);
  var url = this.apiUrl({ platform: this.platform === 'all' ? null : this.platform, limit: this.limit, cursor: this.next });
  return getJson(url).then(function (data) {
    if (!data || !Array.isArray(data.items)) throw new Error('shape');
    var have = {};
    self.items.forEach(function (it) { have[it.id] = 1; });
    var items = sanitize(data.items).filter(function (it) { return !have[it.id]; });
    return self.prefetch(items).then(function () {
      if (seq !== self.seq) return false;
      self.next = typeof data.next_cursor === 'string' && data.next_cursor ? data.next_cursor : null;
      if (data.total && typeof data.total === 'object') self.total = data.total;
      var start = self.items.length;
      self.items = self.items.concat(items);
      var lis = self.append(items, start);
      self.updateFoot();
      if (focusNew && lis[0]) {
        var f = lis[0].querySelector('.dcm-rz-hit, .dcm-rz-tile');
        if (f) f.focus(NOSCROLL);
      }
      return true;
    });
  }).catch(function () {
    if (seq !== self.seq) return false;
    var box = self.moreErr;
    box.textContent = '';
    add(box, el('p', 'dcm-rz__msg-d', t('rz_error_more')));
    var b = btn('dcm-rz__btn', t('rz_retry'));
    on(b, 'click', function () { self.loadMore(true); });
    add(box, b);
    box.hidden = false;
    if (focusNew) b.focus(NOSCROLL);
    if (self.more) self.more.hidden = true;
    return false;
  }).then(function (ok) {
    self.busy = false;
    if (self.more) { self.more.removeAttribute('aria-busy'); self.more.hidden = !self.next || !self.moreErr.hidden; }
    return ok;
  });
};

/* == stany == */
P.clearGrid = function () {
  this.stopObserving();
  this.grid.textContent = '';
  this.grid.classList.remove('is-loading', 'is-laid', 'is-flow', 'is-rows');
  this.grid.setAttribute('aria-busy', 'false');
  this.L = null;
};
P.profileLinks = function () {
  var box = el('p', 'dcm-rz__links'), fb = safeUrl(this.root.dataset.fb), ig = safeUrl(this.root.dataset.ig);
  if (fb) add(box, extLink(fb, 'Facebook ↗', 'dcm-rz__link'));
  if (ig) add(box, extLink(ig, 'Instagram ↗', 'dcm-rz__link'));
  return box.firstChild ? box : null;
};
P.showError = function () {
  var self = this;
  this.clearGrid();
  this.foot.hidden = true;
  this.live.textContent = '';
  var m = this.msg;
  m.textContent = '';
  m.className = 'dcm-rz__msg';
  m.setAttribute('role', 'alert');
  add(m, el('p', 'dcm-rz__msg-t', t('rz_error')));
  add(m, el('p', 'dcm-rz__msg-d', t('rz_error_hint')));
  var b = ++this.tries <= 2 && btn('dcm-rz__btn dcm-rz__btn--fill', t('rz_retry'));
  if (b) {
    on(b, 'click', function () {
      self.retryFocus = document.activeElement === b;
      m.hidden = true;
      self.skel.forEach(function (n) { add(self.grid, n.cloneNode(true)); });
      self.grid.classList.add('is-loading');
      self.grid.setAttribute('aria-busy', 'true');
      self.live.textContent = t('rz_loading');
      self.loadFirst();
    });
    add(m, b);
  }
  var links = this.profileLinks();
  if (links) add(m, links);
  m.hidden = false;
  if (this.retryFocus) { this.retryFocus = false; var f = b || m.querySelector('a'); if (f) f.focus(NOSCROLL); }
};
P.showEmpty = function () {
  this.clearGrid();
  this.live.textContent = '';
  if (window.Shopify && Shopify.designMode) {
    var m = this.msg;
    m.textContent = '';
    m.className = 'dcm-rz__msg dcm-rz__msg--editor';
    m.removeAttribute('role');
    add(m, el('p', 'dcm-rz__msg-t', t('rz_editor_empty')));
    add(m, el('p', 'dcm-rz__msg-d', t('rz_editor_hint')));
    m.hidden = false;
  } else {
    this.root.hidden = true;
  }
};
P.showEmptyFilter = function () {
  var self = this, m = this.msg;
  this.clearGrid();
  this.renderFilters();
  this.foot.hidden = true;
  m.textContent = '';
  m.className = 'dcm-rz__msg dcm-rz__msg--filter';
  m.removeAttribute('role');
  add(m, el('p', 'dcm-rz__msg-d', t('rz_empty_' + this.platform)));
  var b = btn('dcm-rz__pill', t('rz_show_all'));
  on(b, 'click', function () { self.setPlatform('all', true); });
  add(m, b);
  m.hidden = false;
  this.live.textContent = t('rz_empty_' + this.platform);
};
P.toast = function (text, box, ms) {
  var tEl = box || this.toastEl;
  if (!tEl) return;
  tEl.textContent = text;
  tEl.hidden = false;
  clearTimeout(tEl.__rzT);
  tEl.__rzT = setTimeout(function () { tEl.hidden = true; }, ms || 4000);
};
P.updateFoot = function () {
  var total = this.totalFor(), shown = this.items.length, text = '';
  this.foot.hidden = false;
  if (this.mode === 'page') {
    text = this.next ? t('rz_loaded', { shown: this.fmtNum(shown), total: this.fmtNum(total) }) : t('rz_end', { total: this.fmtNum(total) });
    if (this.more) this.more.hidden = !this.next;
  }
  this.status.textContent = text;
  this.status.hidden = !text;
  this.live.textContent = '';
  if (this.countEl) this.countEl.textContent = this.plural('rz_count', total);
  if (this.skip) this.skip.hidden = shown <= 12;
};

/* == filtry i widok == */
P.renderFilters = function () {
  var self = this, box = this.filtersEl, tt = this.total || {};
  if (!box) return;
  if (!(this.filters && tt.facebook > 0 && tt.instagram > 0)) { box.hidden = true; return; }
  if (!box.firstChild) {
    [['all', 'rz_filter_all'], ['facebook', 'rz_filter_facebook', 'fb'], ['instagram', 'rz_filter_instagram', 'ig']].forEach(function (f) {
      var b = btn('dcm-rz__pill');
      if (f[2]) add(b, icon(f[2]));
      add(b, el('span', null, t(f[1])));
      b.setAttribute('data-rz-platform', f[0]);
      on(b, 'click', function () { self.setPlatform(f[0]); });
      add(box, b);
    });
  }
  each(box.children, function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-rz-platform') === self.platform)); });
  box.hidden = false;
};
P.setPlatform = function (p, focusPill) {
  if (p === this.platform) return;
  this.platform = p;
  this.next = null; /* bez kursora starej listy */
  this.renderFilters();
  this.grid.style.opacity = '0.4';
  this.moreErr.hidden = true;
  this.loadFirst();
  if (focusPill && this.filtersEl) { var b = this.filtersEl.querySelector('[data-rz-platform="' + p + '"]'); if (b) b.focus(); }
};
P.setView = function (v) {
  if (v !== 'grid' && v !== 'posts') return;
  if (v === this.view) return;
  this.view = v;
  this.root.classList.toggle('is-posts', v === 'posts');
  each(this.root.querySelectorAll('[data-rz-view]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-rz-view') === v)); });
  try { localStorage.setItem('dcm-rz-view', v); } catch (e) {}
  if (this.items.length && !this.mq.matches) this.render();
  this.live.textContent = t('rz_view_label') + ': ' + t('rz_view_' + v);
};

/* == render == */
P.kind = function () { return this.mq.matches || (this.mode === 'page' && this.view === 'posts') ? 'card' : 'tile'; };
P.lis = function () { return Array.prototype.slice.call(this.grid.children); };
P.render = function () {
  var kind = this.kind(), list = this.items;
  if (this.mode === 'module') {
    /* moduł: pełne rzędy */
    if (kind === 'tile') list = list.slice(0, 9);
    var cols = this.mcols = this.metrics().cols;
    if (list.length > cols) list = list.slice(0, list.length - list.length % cols);
  }
  this.shown = list;
  this.curKind = kind;
  var frag = document.createDocumentFragment(), self = this;
  list.forEach(function (it, i) { add(frag, self.buildItem(it, i, kind)); });
  this.clearGrid();
  add(this.grid, frag);
  this.layoutAll();
};
P.append = function (items, start) {
  var self = this, kind = this.curKind || this.kind();
  var lis = items.map(function (it, i) { var li = self.buildItem(it, start + i, kind); add(self.grid, li); return li; });
  if (this.isFlow() || !this.L) { this.layoutAll(); return lis; }
  this.place(lis, start);
  this.syncCaptions(lis);
  this.observe(lis);
  return lis;
};
P.buildItem = function (it, i, kind) {
  var li = el('li', 'dcm-rz__item', null, { 'data-id': it.id, 'data-variant': it.variant, 'data-platform': it.platform });
  add(li, kind === 'tile' ? this.buildTile(it, i) : this.buildCard(it, i));
  return li;
};
P.head = function (it) {
  var h = el('header', 'dcm-rz-head'), who = el('span', 'dcm-rz-who'), meta = el('span', 'dcm-rz-meta');
  var ig = it.platform === 'instagram', av = avatar(ig);
  var name = it.author && typeof it.author.name === 'string' && it.author.name ? it.author.name : (ig ? 'decomura_art' : 'DECOMURA');
  add(who, el('span', 'dcm-rz-name', name));
  var d = this.fmtDate(it.posted_at);
  if (d) {
    add(meta, el('time', null, d, { datetime: it.posted_at.slice(0, 10) }));
    add(meta, txt(' · '));
  }
  add(meta, txt((ig ? 'Instagram · ' : '') + this.typeText(it)));
  add(who, meta);
  if (!ig) add(who, el('span', 'dcm-rz-vh', 'Facebook'));
  add(h, av);
  add(h, who);
  return h;
};
P.buildCard = function (it, i) {
  var self = this, art = el('article', 'dcm-rz-card'), inner = el('div', 'dcm-rz-card__in');
  var hid = 'rz-' + this.sid + '-' + (++UID);
  art.setAttribute('aria-labelledby', hid);
  var hh = el(this.level, 'dcm-rz-vh', t('rz_card_heading', { label: this.label(it) }));
  hh.id = hid;
  add(inner, hh);
  add(inner, this.head(it));
  if (it.caption) {
    var w = el('div', 'dcm-rz-capw'), p = el('p', 'dcm-rz-cap', it.caption, { lang: 'pl', id: hid + '-c' });
    var more = btn('dcm-rz-more', t('rz_read_more'));
    more.hidden = true;
    more.setAttribute('aria-controls', hid + '-c');
    if (this.mq.matches) more.setAttribute('aria-haspopup', 'dialog'); else more.setAttribute('aria-expanded', 'false');
    on(more, 'click', function () {
      if (self.isFlow()) {
        var open = !p.classList.contains('is-open');
        p.classList.toggle('is-open', open);
        more.classList.toggle('is-open', open);
        more.textContent = t(open ? 'rz_see_less' : 'rz_read_more');
        more.setAttribute('aria-expanded', String(open));
      } else {
        self.openDetail(it, 0, more, true, true);
      }
    });
    add(w, p);
    add(w, more);
    add(inner, w);
  }
  var media = this.media(it, i);
  if (isShare(it) && it.shared_from && typeof it.shared_from.name === 'string' && it.shared_from.name) {
    var sh = el('div', 'dcm-rz-share'), sp = el('div', 'dcm-rz-share__head'), sw = el('span', 'dcm-rz-who');
    add(sp, attrs(el('span', 'dcm-rz-av dcm-rz-av--p', it.shared_from.name.trim().charAt(0).toUpperCase()), HIDE));
    add(sw, el('span', 'dcm-rz-name', it.shared_from.name));
    add(sw, el('span', 'dcm-rz-meta', t('rz_type_share')));
    add(sp, sw);
    add(sh, sp);
    add(sh, media);
    add(inner, sh);
  } else {
    add(inner, media);
  }
  var st = this.statsBlock(it);
  if (st) add(inner, st);
  var pat = this.patternBar(it);
  if (pat) add(inner, pat);
  add(art, inner);
  return art;
};
P.img = function (m, eager, sizes) {
  var im = el('img', 'dcm-rz-img'), src = safeUrl(m.src), small = safeUrl(m.src_small), w = num(m.width), h = num(m.height);
  attrs(im, { alt: '', decoding: 'async', loading: eager ? 'eager' : 'lazy' });
  if (w && h) attrs(im, { width: Math.round(w), height: Math.round(h) });
  if (src && small && small !== src && w && h) {
    var sw = Math.round(w >= h ? Math.min(480, w) : Math.min(480, h) * w / h);
    attrs(im, { srcset: small + ' ' + sw + 'w, ' + src + ' ' + Math.round(w) + 'w', sizes: sizes });
  }
  im.setAttribute('src', src || small);
  on(im, 'error', function () {
    var host = im.parentNode;
    if (!host) return;
    host.removeChild(im);
    add(host, unavailable());
  });
  return im;
};
P.media = function (it, i) {
  var self = this, md = it.media, imgs = images(md), video = playable(it);
  var alb = imgs.length >= 2 && !video && (it.variant === 'album' || it.variant === 'share_partner' || it.variant === 'photo');
  var box = el('div', 'dcm-rz-media' + (alb ? ' dcm-rz-media--alb' : ''));
  var hit = btn('dcm-rz-hit');
  hit.setAttribute('aria-haspopup', 'dialog');
  var sizes = '(min-width: 1200px) 351px, (min-width: 990px) calc((100vw - 148px) / 3), (min-width: 750px) calc((100vw - 116px) / 2), 100vw';
  var count = this.count(it), lay = alb ? albumLayout(imgs) : [0, clampRatio(md.ratio)];
  box.style.setProperty('--rz-r', String(this.mode === 'module' ? clamp(lay[1], 0.8, 1) : lay[1]));
  if (alb) {
    var n = Math.min(5, imgs.length), grid = el('span', 'dcm-rz-alb dcm-rz-alb--' + lay[0]);
    for (var k = 0; k < n; k++) {
      var c = el('span', 'dcm-rz-alb__c', null, { 'data-index': k });
      add(c, this.img(imgs[k], i < 3, '(min-width: 750px) 240px, 50vw'));
      if (k === 4 && count > 5) add(c, el('span', 'dcm-rz-alb__more', '+' + (count - 5)));
      add(grid, c);
    }
    add(hit, grid);
    hit.setAttribute('aria-label', t('rz_open_album', { photos: this.plural('rz_photos', count) }));
  } else {
    var cover = coverOf(md);
    if (cover && hexColor(cover.color)) box.style.setProperty('--rz-bg', cover.color);
    add(hit, cover ? this.img(cover, i < 3, sizes) : unavailable());
    if (video) {
      add(hit, el('span', 'dcm-rz-play', null, HIDE)).appendChild(icon('play', ''));
      var dur = fmtDur(video.duration_s);
      if (dur) add(hit, el('span', 'dcm-rz-pill', dur, HIDE));
      hit.setAttribute('aria-label', it.variant === 'video' && this.mq.matches ? t('rz_play') + (dur ? ', ' + dur : '') : t('rz_open', { label: this.label(it) }));
      if (it.variant === 'video') hit.removeAttribute('aria-haspopup');
    } else {
      if (count > 1) add(hit, el('span', 'dcm-rz-pill dcm-rz-pill--tr', '1/' + count, HIDE));
      else if (it.variant === 'share_ig') add(hit, icon('ig', 'dcm-rz-ic dcm-rz-badge'));
      hit.setAttribute('aria-label', t('rz_open', { label: this.label(it) }));
    }
  }
  on(hit, 'click', function (e) {
    var cell = e.target && e.target.closest ? e.target.closest('[data-index]') : null;
    var start = cell && e.detail > 0 ? parseInt(cell.getAttribute('data-index'), 10) || 0 : 0;
    if (it.variant === 'video' && video && self.mq.matches) { self.playInline(it, box); return; }
    self.openDetail(it, start, hit, true);
  });
  add(box, hit);
  return box;
};
/* fail: płyta „niedostępny” */
P.video = function (it, v, preload, fail) {
  var video = el('video', null, null, { controls: '', playsinline: '', preload: preload, poster: safeUrl(v.poster) || (it.media.cover && safeUrl(it.media.cover.src)) || null, src: safeUrl(v.src), 'aria-label': t('rz_video_label', { label: this.label(it) }) });
  on(video, 'error', fail);
  on(video, 'play', function () { if (expiringSoon(v)) { video.pause(); fail(); } });
  PLAYER.track(video);
  return video;
};
function play(video) { var pr = video.play(); if (pr && pr.catch) pr.catch(noop); }
P.playInline = function (it, box) {
  var v = playable(it), perma = safeUrl(it.permalink);
  function fail() { box.textContent = ''; add(box, unavailable(perma)); }
  if (!v || expiringSoon(v)) { fail(); return; }
  box.textContent = '';
  var video = add(box, this.video(it, v, 'auto', fail));
  if (v.stable === false) add(box, el('span', 'dcm-rz-note', t('rz_from_meta')));
  video.focus(NOSCROLL);
  play(video);
};
P.buildTile = function (it, i) {
  var self = this, md = it.media, b = btn('dcm-rz-tile'), ar = el('span', 'dcm-rz-tile__ar');
  attrs(b, { 'aria-haspopup': 'dialog', 'aria-label': t('rz_open', { label: this.label(it) }) });
  ar.style.setProperty('--rz-r', String(this.mode === 'module' ? 0.8 : tileRatio(md.ratio)));
  add(b, ar);
  var cover = coverOf(md);
  if (cover && hexColor(cover.color)) b.style.setProperty('--rz-bg', cover.color);
  add(b, cover ? this.img(cover, i < 6, 'calc((100vw - 6px) / 3)') : unavailable());
  var ic = playable(it) || it.variant === 'reel' || it.variant === 'video' ? 'reel' : (this.count(it) > 1 ? 'album' : (it.variant === 'share_ig' ? 'ig' : null));
  if (ic) add(b, icon(ic, 'dcm-rz-ic dcm-rz-badge'));
  on(b, 'click', function () { self.openDetail(it, 0, b, true); });
  return b;
};
/* [pole, ikona, klucz] tylko dla wartości > 0 */
P.stats = function (it) {
  var s = it.stats || {};
  return [['views', 'eye', 'rz_views'], ['reactions', 'heart', 'rz_reactions'], ['comments', 'chat', 'rz_comments'], ['shares', 'repost', 'rz_shares']].filter(function (k) { return num(s[k[0]]) > 0; }).map(function (k) { return k.concat(s[k[0]]); });
};
P.statsBlock = function (it) {
  var self = this, list = this.stats(it), box = el('div', 'dcm-rz-stats');
  list.forEach(function (k) {
    var vis = add(box, el('span', null, null, HIDE));
    add(vis, icon(k[1]));
    add(vis, txt(self.fmtNum(k[3], true)));
    add(box, el('span', 'dcm-rz-vh', self.plural(k[2], k[3])));
  });
  return list.length ? box : null;
};
P.statsText = function (it) {
  var self = this;
  return this.stats(it).map(function (k) { return self.plural(k[2], k[3]); }).join(' · ');
};
P.productUrl = function (h) { return this.base + 'products/' + encodeURIComponent(h); };
P.patternBar = function (it) {
  var h = handleOf(it);
  if (!h) return null;
  var st = productState(this.base, h);
  if (st.done && !st.data) return null;
  var a = el('a', 'dcm-rz-pat', null, { href: this.productUrl(h) });
  var th = el('img', 'dcm-rz-pat__th', null, { alt: '', width: 48, height: 48, loading: 'lazy', decoding: 'async' });
  var tx = el('span', 'dcm-rz-pat__tx'), title = el('span', 'dcm-rz-pat__t', '\u00a0');
  add(tx, el('span', 'dcm-rz-lbl', t('rz_pattern')));
  add(tx, title);
  add(a, th);
  add(a, tx);
  add(a, icon('arrow'));
  function put(d) {
    title.textContent = d.title;
    a.setAttribute('aria-label', t('rz_pattern_label', { title: d.title }));
    var src = d.image && safeUrl(d.image.src);
    if (src) th.setAttribute('src', src);
    a.classList.remove('dcm-rz-pat--wait');
    a.removeAttribute('aria-hidden');
    a.removeAttribute('tabindex');
  }
  if (st.done) put(st.data);
  else {
    attrs(a, { 'aria-hidden': 'true', tabindex: '-1' });
    a.classList.add('dcm-rz-pat--wait');
    st.p.then(put, function () { if (a.parentNode) a.parentNode.removeChild(a); });
  }
  on(a, 'click', function () { track('realizacje_pattern_click', it); });
  return a;
};

/* == układ: siatka z jawnym umieszczeniem == */
P.isFlow = function () { return this.curKind === 'card' && !this.mq.matches; };
P.metrics = function () {
  var cs = getComputedStyle(this.grid);
  return { cols: parseInt(cs.getPropertyValue('--rz-cols'), 10) || 1, gap: parseFloat(cs.getPropertyValue('--rz-gap')) || 0, u: parseFloat(cs.getPropertyValue('--rz-u')) || 4 };
};
function inner(li) { return li.querySelector('.dcm-rz-card__in, .dcm-rz-tile__ar') || li; }
P.layoutAll = function () {
  var lis = this.lis(), g = this.grid;
  this.stopObserving();
  lis.forEach(function (li) { li.style.gridColumn = ''; li.style.gridRow = ''; });
  g.classList.remove('is-laid');
  if (this.isFlow() || this.mode === 'module') {
    g.classList.add(this.isFlow() ? 'is-flow' : 'is-rows');
    this.L = null;
  } else {
    g.classList.remove('is-flow');
    var m = this.metrics(), acc = [];
    for (var c = 0; c < m.cols; c++) acc.push(0);
    this.L = { m: m, acc: acc, col: [], width: g.clientWidth };
    this.place(lis, 0);
    g.classList.add('is-laid');
  }
  this.syncCaptions(lis);
  this.observe(lis);
};
P.place = function (lis, start) {
  var L = this.L, m = L.m;
  if (!lis.length) return;
  var W = lis[0].getBoundingClientRect().width, tol = Math.min(0.2 * W, 72), c0 = lis[0].firstElementChild;
  /* + obramowanie karty (poza wnętrzem) */
  if (L.b == null) L.b = c0 ? c0.offsetHeight - c0.clientHeight : 0;
  var hs = lis.map(function (li) { return inner(li).getBoundingClientRect().height; });
  lis.forEach(function (li, i) {
    var min = Math.min.apply(null, L.acc), c = 0;
    while (c < L.acc.length - 1 && L.acc[c] > min + tol) c++;
    var k = Math.max(1, Math.ceil((hs[i] + L.b + m.gap) / m.u));
    li.style.gridColumn = String(c + 1);
    li.style.gridRow = (L.acc[c] / m.u + 1) + ' / span ' + k;
    li.__rzH = hs[i];
    L.col[start + i] = c;
    L.acc[c] += k * m.u;
  });
};
P.reflowRows = function () {
  var L = this.L;
  if (!L) return;
  var m = L.m, lis = this.lis(), acc = L.acc.map(function () { return 0; });
  var hs = lis.map(function (li) { return inner(li).getBoundingClientRect().height; });
  lis.forEach(function (li, i) {
    var c = L.col[i] != null ? L.col[i] : 0, k = Math.max(1, Math.ceil((hs[i] + L.b + m.gap) / m.u));
    li.style.gridRow = (acc[c] / m.u + 1) + ' / span ' + k;
    li.__rzH = hs[i];
    acc[c] += k * m.u;
  });
  L.acc = acc;
  this.syncCaptions(lis);
};
P.syncCaptions = function (lis) {
  lis.forEach(function (li) {
    var p = li.querySelector('.dcm-rz-cap'), b = li.querySelector('.dcm-rz-more');
    if (p && b && !p.classList.contains('is-open')) b.hidden = !(p.scrollHeight > p.clientHeight + 1);
  });
};
P.observe = function (lis) {
  var self = this;
  if (typeof ResizeObserver !== 'function') return;
  if (!this.roItems) {
    this.roItems = new ResizeObserver(function (entries) {
      if (!self.L) return;
      var changed = entries.some(function (en) {
        var li = en.target.closest('li');
        return li && Math.abs(en.target.getBoundingClientRect().height - (li.__rzH || 0)) > 1;
      });
      if (changed) { cancelAnimationFrame(self.rafRows); self.rafRows = requestAnimationFrame(function () { self.reflowRows(); }); }
    });
    /* moduł: nowa liczba kolumn = pełne rzędy */
    this.roGrid = new ResizeObserver(function () {
      var L = self.L, c = self.metrics().cols;
      if (L ? Math.abs(self.grid.clientWidth - L.width) > 1 || c !== L.m.cols : self.mode === 'module' && c !== self.mcols) {
        cancelAnimationFrame(self.rafAll);
        self.rafAll = requestAnimationFrame(function () { if (L) self.layoutAll(); else self.render(); });
      }
    });
  }
  this.roGrid.observe(this.grid);
  lis.forEach(function (li) { self.roItems.observe(inner(li)); });
};
P.stopObserving = function () {
  if (this.roItems) this.roItems.disconnect();
  if (this.roGrid) this.roGrid.disconnect();
};

/* == szczegół == */
P.dialog = function () {
  if (this.dlg) return this.dlg;
  var self = this, hid = 'rz-dlg-' + this.sid, d = {};
  function ib(name, label, withText, cls) {
    var b = btn(cls || 'dcm-rz-ibtn');
    add(b, icon(name));
    if (withText) add(b, el('span', null, label)); else b.setAttribute('aria-label', label);
    return b;
  }
  function clicks(list, fn) { list.forEach(function (b) { on(b, 'click', fn); }); }
  var E = d.el = el('dialog', 'dcm-rz-dlg', null, { 'aria-labelledby': hid });
  var top = add(E, el('div', 'dcm-rz-dlg__top'));
  d.closeTop = add(top, ib('close', t('rz_close'), 1));
  d.countTop = add(top, el('span', 'dcm-rz-dlg__count', null, HIDE));
  d.shareTop = add(top, ib('share', t('rz_share'), 1));
  d.navPrev = add(E, ib('left', t('rz_prev_item'), 0, 'dcm-rz-dlg__nav dcm-rz-dlg__nav--prev'));
  d.navNext = add(E, ib('right', t('rz_next_item'), 0, 'dcm-rz-dlg__nav dcm-rz-dlg__nav--next'));
  var box = add(E, el('div', 'dcm-rz-dlg__box'));
  d.stage = add(box, el('div', 'dcm-rz-dlg__stage'));
  var panel = add(box, el('aside', 'dcm-rz-dlg__panel')), sc = add(panel, el('div', 'dcm-rz-dlg__scroll'));
  d.h = add(sc, el('h2', 'dcm-rz-vh', null, { id: hid }));
  d.shared = add(sc, el('p', 'dcm-rz-dlg__shared'));
  var head = add(sc, el('div', 'dcm-rz-dlg__head'));
  d.av = add(head, avatar());
  var who = add(head, el('span', 'dcm-rz-who'));
  d.name = add(who, el('span', 'dcm-rz-name'));
  d.meta = add(who, el('span', 'dcm-rz-meta'));
  d.close = add(head, ib('close', t('rz_close')));
  d.capw = add(sc, el('div', 'dcm-rz-dlg__capw'));
  d.cap = add(d.capw, el('p', 'dcm-rz-dlg__cap', null, { lang: 'pl', id: hid + '-c', tabindex: '-1' }));
  d.more = attrs(add(d.capw, btn('dcm-rz-dlg__more', t('rz_see_more'))), { 'aria-controls': hid + '-c', 'aria-expanded': 'false' });
  d.stats = add(sc, el('p', 'dcm-rz-dlg__stats'));
  d.pat = add(sc, el('div', 'dcm-rz-dlg__pat'));
  d.patImg = add(d.pat, el('img', null, null, { alt: '', width: 72, height: 72, decoding: 'async' }));
  var ptx = add(d.pat, el('span')), bts = add(d.pat, el('div', 'dcm-rz-dlg__btns'));
  add(ptx, el('span', 'dcm-rz-lbl', t('rz_pattern')));
  d.patTitle = add(ptx, el('span', 'dcm-rz-dlg__pat-t'));
  d.see = add(bts, el('a', 'dcm-rz-cta', t('rz_see_pattern'), { 'data-rz-see': '' }));
  d.sample = add(bts, el('a', 'dcm-rz-cta dcm-rz-cta--fill', t('rz_order_sample')));
  var foot = add(panel, el('div', 'dcm-rz-dlg__foot'));
  d.ext = add(foot, el('a', 'dcm-rz-dlg__ext', null, { target: '_blank', rel: 'noopener' }));
  d.fPrev = add(foot, ib('left', t('rz_prev_item'), 0, 'dcm-rz-ibtn dcm-rz-dlg__fnav'));
  d.count = add(foot, el('span', 'dcm-rz-dlg__count', null, HIDE));
  d.fNext = add(foot, ib('right', t('rz_next_item'), 0, 'dcm-rz-ibtn dcm-rz-dlg__fnav'));
  d.share = attrs(add(foot, ib('share', t('rz_share'))), { 'data-rz-share': '' });
  var bar = add(E, el('div', 'dcm-rz-dlg__bar'));
  d.bPrev = add(bar, ib('left', t('rz_prev_item'), 0, ' '));
  d.bCta = add(bar, el('a', 'dcm-rz-cta'));
  d.bNext = add(bar, ib('right', t('rz_next_item'), 0, ' '));
  d.live = add(E, el('p', 'dcm-rz-vh', null, { 'aria-live': 'polite' }));
  d.toast = add(E, el('p', 'dcm-rz__toast dcm-rz-dlg__toast', null, { role: 'status' }));
  d.toast.hidden = true;
  clicks([d.closeTop, d.close], function () { self.closeDetail(); });
  clicks([d.navPrev, d.fPrev, d.bPrev], function () { self.step(-1); });
  clicks([d.navNext, d.fNext, d.bNext], function () { self.step(1); });
  clicks([d.share, d.shareTop], function () { self.share(); });
  clicks([d.see], function () { track('realizacje_pattern_click', self.cur); });
  clicks([d.bCta], function () { if (d.bCta.classList.contains('dcm-rz-cta--fill')) track('realizacje_pattern_click', self.cur); });
  clicks([d.sample], function () { track('realizacje_sample_click', self.cur); });
  clicks([d.more], function () {
    var open = !d.cap.classList.contains('is-open');
    d.cap.classList.toggle('is-open', open);
    d.more.textContent = t(open ? 'rz_see_less' : 'rz_see_more');
    d.more.setAttribute('aria-expanded', String(open));
  });
  on(E, 'cancel', function (e) { e.preventDefault(); self.closeDetail(); });
  on(E, 'click', function (e) { if (e.target === E) self.closeDetail(); });
  on(E, 'keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var tg = e.target, tag = tg && tg.tagName;
    if (tag === 'VIDEO' || tag === 'INPUT' || tag === 'TEXTAREA' || (tg && tg.isContentEditable)) return;
    e.preventDefault();
    var dir = e.key === 'ArrowLeft' ? -1 : 1;
    if (d.stage.contains(tg) && self.albumLen() > 1) self.setPhoto(self.photo + dir, true); else self.step(dir);
  });
  /* gesty arkusza: w dół zamyka, w poziomie zmienia zdjęcie */
  var g = null, sheet = window.matchMedia(SHEET);
  on(E, 'touchstart', function (e) {
    var p = e.touches[0], tg = e.target;
    g = e.touches.length === 1 && sheet.matches ? { x: p.clientX, y: p.clientY, t: Date.now(), dx: 0, dy: 0, down: top.contains(tg) || box.scrollTop <= 0, alb: self.albumLen() > 1 && self.albumFrame.contains(tg) } : null;
  }, { passive: true });
  on(E, 'touchmove', function (e) {
    if (!g) return;
    g.dx = e.touches[0].clientX - g.x; g.dy = e.touches[0].clientY - g.y;
    if (g.drag || (g.down && g.dy > 8 && g.dy > Math.abs(g.dx))) {
      g.drag = true;
      e.preventDefault();
      E.style.transform = 'translateY(' + Math.max(0, g.dy) + 'px)';
    } else if (g.alb && Math.abs(g.dx) > Math.abs(g.dy)) {
      e.preventDefault();
    }
  }, { passive: false });
  function end() {
    var s = g;
    g = null;
    if (!s) return;
    if (s.drag) {
      E.style.transition = 'transform .2s';
      E.style.transform = '';
      setTimeout(function () { E.style.transition = ''; }, 220);
      if (s.dy > 96 || (s.dy > 24 && s.dy / Math.max(1, Date.now() - s.t) > 0.5)) self.closeDetail();
    } else if (s.alb && Math.abs(s.dx) > 40 && Math.abs(s.dx) > 1.5 * Math.abs(s.dy)) {
      self.setPhoto(self.photo + (s.dx < 0 ? 1 : -1), false);
    }
  }
  on(E, 'touchend', end);
  on(E, 'touchcancel', end);
  add(this.root, E);
  return (this.dlg = d);
};
P.albumLen = function () { return this.cur && !playable(this.cur) ? images(this.cur.media).length : 0; };
/* moduł: pozycje z siatki (okno otwarte z #r= na obciętej: wszystkie) */
P.navItems = function () { return this.mode === 'module' && !this.all ? this.shown || [] : this.items; };
P.indexOf = function (it) {
  var list = this.navItems();
  for (var i = 0; i < list.length; i++) { if (list[i].id === it.id) return i; }
  return -1;
};
P.closeBtn = function () { var d = this.dlg; return d.close.getClientRects().length ? d.close : d.closeTop; };
/* how: true = klik, 'hash' = wejście z #r=, 'pop' = Wstecz/Dalej */
P.openDetail = function (it, photo, opener, how, focusCaption) {
  var d = this.dialog();
  if (typeof d.el.showModal !== 'function') {
    var u = safeUrl(it.permalink);
    if (u) window.open(u, '_blank', 'noopener');
    return;
  }
  this.cur = it;
  this.photo = photo || 0;
  var wasOpen = d.el.open;
  if (!wasOpen) {
    PLAYER.pause();
    this.all = (this.shown || []).indexOf(it) < 0;
    this.opener = opener || null;
    var li = opener && opener.closest('li');
    this.openerId = li ? li.getAttribute('data-id') : null;
  }
  this.fill(how === true);
  if (!wasOpen) {
    d.el.showModal();
    document.documentElement.classList.add('dcm-rz-lock');
    this.pushed = !!how;
    try {
      if (how === 'hash') history.replaceState(history.state, '', cleanUrl());
      if (how === true || how === 'hash') history.pushState({ dcmRz: it.id }, '', '#r=' + encodeURIComponent(it.id));
    } catch (e) { this.pushed = how === 'pop'; }
  }
  this.syncDlgCaption();
  (focusCaption && it.caption ? d.cap : this.closeBtn()).focus(NOSCROLL);
  track('realizacje_open', it);
};
P.closeDetail = function (fromPop) {
  var d = this.dlg;
  if (!d || !d.el.open) return;
  PLAYER.stopIn(d.stage);
  d.el.close();
  if (!document.querySelector('dialog.dcm-rz-dlg[open]')) document.documentElement.classList.remove('dcm-rz-lock');
  if (!fromPop) {
    if (this.pushed) { this.ignorePop = true; history.back(); }
    else if (/^#r=/.test(location.hash)) { try { history.replaceState(history.state, '', cleanUrl()); } catch (e) {} }
  }
  this.pushed = false;
  d.stage.textContent = '';
  var o = this.opener, id = this.openerId;
  this.opener = null;
  if (!(o && o.isConnected) && id) o = this.lis().filter(function (li) { return li.getAttribute('data-id') === id; }).map(function (li) { return li.querySelector('.dcm-rz-hit, .dcm-rz-tile'); })[0];
  if (o) o.focus(NOSCROLL);
};
P.popstate = function () {
  if (this.ignorePop) { this.ignorePop = false; return; }
  if (this.dlg && this.dlg.el.open) { this.pushed = false; this.closeDetail(true); } else this.handleHash('pop');
};
P.step = function (dir) {
  var self = this, list = this.navItems(), i = this.indexOf(this.cur), d = this.dlg;
  if (i < 0) return;
  var j = i + dir;
  if (j < 0) return;
  if (j >= list.length) {
    if (this.mode === 'page' && this.next) {
      this.loadMore(false).then(function (ok) {
        if (!d.el.open) return;
        if (ok) self.step(dir);
        else if (!self.moreErr.hidden) {
          self.navState(d.navPrev.disabled, true);
          self.toast(t('rz_error_more'), d.toast);
        }
      });
    }
    return;
  }
  PLAYER.stopIn(d.stage);
  this.cur = list[j];
  this.photo = 0;
  this.fill(false);
  this.syncDlgCaption();
  /* fokus nie może spaść na <body> */
  var a = document.activeElement;
  if (!d.el.contains(a) || !a.getClientRects().length) this.closeBtn().focus(NOSCROLL);
  if (/^#r=/.test(location.hash)) { try { history.replaceState({ dcmRz: this.cur.id }, '', '#r=' + encodeURIComponent(this.cur.id)); } catch (e) {} }
  this.dlg.live.textContent = this.dlg.count.textContent;
  track('realizacje_open', this.cur);
};
P.share = function () {
  var self = this, it = this.cur;
  var url = location.origin + cleanUrl() + '#r=' + encodeURIComponent(it.id);
  if (navigator.share) { navigator.share({ title: document.title, url: url }).catch(noop); return; }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(url).then(function () { self.toast(t('rz_copied'), self.dlg.toast, 2000); }, noop);
  }
};
P.syncDlgCaption = function () {
  var d = this.dlg;
  if (!this.cur.caption) return;
  d.more.hidden = !(d.cap.scrollHeight > d.cap.clientHeight + 1);
};
P.fill = function (byUser) {
  var self = this, d = this.dlg, it = this.cur, i = this.indexOf(it), ig = it.platform === 'instagram';
  d.h.textContent = t('rz_card_heading', { label: this.label(it) });
  d.shared.textContent = '';
  var sf = it.shared_from;
  if (isShare(it) && sf && typeof sf.name === 'string' && sf.name) {
    var parts = t('rz_shared_post', { name: '\u0000' }).split('\u0000'), su = safeUrl(sf.url);
    add(d.shared, icon('share'));
    var line = el('span');
    add(line, txt(parts[0] || ''));
    add(line, su ? extLink(su, sf.name) : el('span', null, sf.name));
    add(line, txt(parts[1] || ''));
    add(d.shared, line);
    d.shared.hidden = false;
  } else {
    d.shared.hidden = true;
  }
  d.av = avatar(ig, d.av);
  d.name.textContent = it.author && it.author.name ? it.author.name : (ig ? 'decomura_art' : 'DECOMURA');
  var date = this.fmtDate(it.posted_at);
  d.meta.textContent = (date ? date + ' · ' : '') + (ig ? 'Instagram' : 'Facebook');
  d.cap.classList.remove('is-open');
  d.more.textContent = t('rz_see_more');
  d.more.setAttribute('aria-expanded', 'false');
  d.more.hidden = true;
  d.cap.textContent = it.caption || '';
  d.capw.hidden = !it.caption;
  var stats = this.statsText(it);
  d.stats.textContent = stats;
  d.stats.hidden = !stats;
  var h = handleOf(it), perma = safeUrl(it.permalink), onKey = ig ? 'rz_on_instagram' : 'rz_on_facebook';
  d.pat.hidden = true;
  function barCta(prod) {
    var b = d.bCta;
    b.className = prod ? 'dcm-rz-cta dcm-rz-cta--fill' : 'dcm-rz-cta';
    b.textContent = t(prod ? 'rz_see_pattern' : onKey);
    attrs(b, prod ? { href: self.productUrl(h) } : { href: perma, target: '_blank', rel: 'noopener' });
    if (prod) b.removeAttribute('target');
    b.hidden = !(prod || perma);
  }
  function putProduct(prod) {
    if (self.cur !== it) return;
    d.patTitle.textContent = prod.title;
    var src = prod.image && safeUrl(prod.image.src);
    if (src) d.patImg.setAttribute('src', src); else d.patImg.removeAttribute('src');
    attrs(d.see, { href: self.productUrl(h), 'aria-label': t('rz_pattern_label', { title: prod.title }) });
    attrs(d.sample, { href: self.sampleHref(prod, h), 'aria-label': t('rz_sample_label', { title: prod.title }) });
    d.pat.hidden = false;
    barCta(true);
  }
  barCta(false);
  if (h) {
    var st = productState(this.base, h);
    if (st.done && st.data) putProduct(st.data);
    else if (!st.done) st.p.then(putProduct, noop);
  }
  if (perma) {
    d.ext.textContent = t(onKey);
    add(d.ext, el('span', 'dcm-rz-vh', ' ' + t('rz_new_tab')));
    d.ext.setAttribute('href', perma);
    d.ext.hidden = false;
  } else {
    d.ext.hidden = true;
  }
  var n = this.navItems().length, page = this.mode === 'page', counter = i >= 0 ? (i + 1) + ' / ' + (page ? this.totalFor() : n) : '';
  d.count.textContent = counter;
  d.countTop.textContent = counter;
  this.navState(i <= 0, i < 0 || (i >= n - 1 && !(page && this.next)));
  this.fillStage(byUser);
};
P.navState = function (noPrev, noNext) {
  var d = this.dlg, ae = document.activeElement, pr = [d.navPrev, d.fPrev, d.bPrev], nx = [d.navNext, d.fNext, d.bNext];
  pr.forEach(function (b) { b.disabled = noPrev; });
  nx.forEach(function (b) { b.disabled = noNext; });
  /* fokus z wyłączonego przycisku: drugi kierunek */
  var k = pr.indexOf(ae), to = k >= 0 ? nx[k] : pr[nx.indexOf(ae)];
  if (to && ae.disabled) (to.disabled ? this.closeBtn() : to).focus(NOSCROLL);
};
P.sampleHref = function (prod, handle) {
  var u;
  try { u = new URL(this.samples, location.origin); } catch (e) { return this.samples; }
  if (prod.id != null) u.searchParams.set('product_id', String(prod.id));
  u.searchParams.set('title', prod.title || '');
  if (typeof prod.design_url === 'string' && prod.design_url) u.searchParams.set('design_url', prod.design_url);
  u.searchParams.set('product_handle', handle);
  u.searchParams.set('utm_source', 'realizacje');
  return u.pathname + u.search;
};
P.frame = function (ratio) {
  var f = el('div', 'dcm-rz-dlg__frame');
  f.style.setProperty('--rz-r', String(clamp(ratio || 1, 0.3, 3)));
  return f;
};
P.stageUnavailable = function (frame) {
  frame.textContent = '';
  add(frame, unavailable(safeUrl(this.cur.permalink), 'dcm-rz-dlg__unav'));
};
P.fillStage = function (byUser) {
  var self = this, d = this.dlg, it = this.cur, md = it.media, stage = d.stage;
  PLAYER.stopIn(stage);
  stage.textContent = '';
  var media = el('div', 'dcm-rz-dlg__media');
  add(stage, media);
  var v = playable(it), imgs = images(md);
  if (v) {
    var r = num(v.width) && num(v.height) ? v.width / v.height : (it.variant === 'reel' ? 0.5625 : 1.7778);
    var frame = this.frame(r);
    add(media, frame);
    if (v.stable === false) add(stage, el('p', 'dcm-rz-dlg__src', t('rz_from_meta')));
    if (expiringSoon(v)) { this.stageUnavailable(frame); return; }
    var video = add(frame, this.video(it, v, 'none', function () { self.stageUnavailable(frame); }));
    var slow = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
    if (byUser && !slow) play(video);
    return;
  }
  if (imgs.length > 1) {
    this.albumFrame = media;
    this.setPhoto(this.photo, false);
    var thumbs = el('div', 'dcm-rz-dlg__thumbs');
    imgs.forEach(function (m, k) {
      var tb = attrs(btn('dcm-rz-dlg__thumb'), { 'aria-label': t('rz_photo_n', { n: k + 1, total: imgs.length }), 'aria-current': String(k === self.photo) });
      var ti = el('img', null, null, { alt: '', loading: 'lazy', decoding: 'async', src: safeUrl(m.src_small) || safeUrl(m.src) });
      add(tb, ti);
      on(tb, 'click', function () { self.setPhoto(k, false); });
      add(thumbs, tb);
    });
    add(stage, thumbs);
    d.thumbs = thumbs;
    return;
  }
  d.thumbs = null;
  var cover = coverOf(md), ex = md.external && safeUrl(md.external.url);
  var fr = this.frame(cover && num(cover.width) ? ratioOf(cover) : clampRatio(md.ratio));
  add(media, fr);
  /* link zewnętrzny także na płycie „niedostępny” */
  function extBtn() {
    if (ex && (it.variant === 'share_ig' || it.variant === 'share_link')) add(fr, extLink(ex, t(md.external.platform === 'instagram' || it.variant === 'share_ig' ? 'rz_on_instagram' : 'rz_open_link'), 'dcm-rz-dlg__extbtn'));
  }
  if (cover) {
    var im = add(fr, el('img', null, null, { alt: '', decoding: 'async', src: safeUrl(cover.src) || safeUrl(cover.src_small) }));
    on(im, 'error', function () { self.stageUnavailable(fr); extBtn(); });
  } else this.stageUnavailable(fr);
  extBtn();
};
P.setPhoto = function (n, keepFocus) {
  var self = this, d = this.dlg, imgs = images(this.cur.media), media = this.albumFrame;
  if (!imgs.length || !media) return;
  n = (n + imgs.length) % imgs.length;
  this.photo = n;
  var m = imgs[n], ae = document.activeElement;
  var refocus = keepFocus && ae && media.contains(ae) && ae.className.indexOf('--prev') > 0 ? 'prev' : 'next';
  media.textContent = '';
  var fr = this.frame(ratioOf(m));
  var im = el('img', null, null, { alt: t('rz_photo_n', { n: n + 1, total: imgs.length }), decoding: 'async', src: safeUrl(m.src) || safeUrl(m.src_small) });
  on(im, 'error', function () { self.stageUnavailable(fr); });
  add(fr, im);
  add(media, fr);
  add(fr, attrs(el('span', 'dcm-rz-dlg__acount', (n + 1) + ' / ' + imgs.length), HIDE));
  var prev = attrs(btn('dcm-rz-dlg__arrow dcm-rz-dlg__arrow--prev'), { 'aria-label': t('rz_prev_photo') });
  add(prev, icon('left'));
  var next = attrs(btn('dcm-rz-dlg__arrow dcm-rz-dlg__arrow--next'), { 'aria-label': t('rz_next_photo') });
  add(next, icon('right'));
  on(prev, 'click', function () { self.setPhoto(self.photo - 1, true); });
  on(next, 'click', function () { self.setPhoto(self.photo + 1, true); });
  add(media, prev);
  add(media, next);
  /* aktywna miniatura w widoku paska */
  if (d.thumbs) {
    each(d.thumbs.children, function (b, k) { b.setAttribute('aria-current', String(k === n)); });
    var s = d.thumbs, a = s.children[n] && s.children[n].getBoundingClientRect(), r = s.getBoundingClientRect();
    if (a && (a.left < r.left || a.right > r.right)) s.scrollLeft += a.left - r.left - (r.width - a.width) / 2;
  }
  d.live.textContent = t('rz_photo_n', { n: n + 1, total: imgs.length });
  if (keepFocus && !d.stage.contains(document.activeElement)) (refocus === 'prev' ? prev : next).focus(NOSCROLL);
};

/* == głęboki link #r=<id> == */
P.handleHash = function (how) {
  var self = this;
  if (how !== 'pop') { if (this.hashDone) return; this.hashDone = true; }
  var owner = null;
  each(document.querySelectorAll('[data-dcm-rz]'), function (n) {
    if (!owner && n.getAttribute('data-mode') === 'page') owner = n;
  });
  if (!owner) owner = document.querySelector('[data-dcm-rz]');
  var m = /^#r=([^&]+)$/.exec(location.hash);
  if (owner !== this.root || !m || !this.hashDone) return;
  how = how || 'hash';
  var id;
  try { id = decodeURIComponent(m[1]); } catch (e) { id = m[1]; }
  for (var i = 0; i < this.items.length; i++) { if (this.items[i].id === id) { this.openDetail(this.items[i], 0, null, how); return; } }
  getJson(this.apiUrl({ id: id })).then(function (data) {
    var it = data && sanitize([data.item])[0];
    if (!it) { var e = new Error('404'); e.status = 404; throw e; }
    return self.prefetch([it]).then(function () { if (location.hash === m[0]) self.openDetail(it, 0, null, how); });
  }).catch(function (e) {
    if (!e || e.status !== 404 || location.hash !== m[0]) return;
    self.toast(t('rz_not_found'));
    try { history.replaceState(history.state, '', cleanUrl()); } catch (x) {}
  });
};

P.destroy = function () {
  this.seq++;
  this.stopObserving();
  window.removeEventListener('popstate', this.onPop);
  if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq); else this.mq.removeListener(this.onMq);
  if (this.dlg && this.dlg.el.open) this.closeDetail(true);
  this.root.__dcmRz = null;
};

function scan(scope) {
  var nodes = [];
  if (scope && scope.matches && scope.matches('[data-dcm-rz]')) nodes.push(scope);
  if (scope && scope.querySelectorAll) nodes = nodes.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-dcm-rz]')));
  nodes.forEach(function (n) { if (!n.__dcmRz) new Inst(n); });
}
on(document, 'shopify:section:load', function (e) { scan(e.target); });
on(document, 'shopify:section:unload', function (e) {
  each(e.target.querySelectorAll('[data-dcm-rz]'), function (n) { if (n.__dcmRz) n.__dcmRz.destroy(); });
});
window.DcmRealizacje = { scan: scan, version: '2026-09-16' };
if (document.readyState === 'loading') on(document, 'DOMContentLoaded', function () { scan(document); });
else scan(document);
})();
